(function () {
  function padTime(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function updateAuthorDates() {
    var twoDaysAgo = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var formattedDate =
      months[twoDaysAgo.getMonth()] + ' ' + twoDaysAgo.getDate() + ', ' + twoDaysAgo.getFullYear();

    document.querySelectorAll('.js-pv-lb-author-info').forEach(function (block) {
      block.innerHTML = block.innerHTML.replace(
        /Last Updated [A-Z][a-z]{2} \d{1,2}, \d{4}/gi,
        'Last Updated ' + formattedDate
      );
    });
  }

  function initOfferTimers() {
    document.querySelectorAll('.js-pv-lb-offer-timer').forEach(function (timerEl) {
      if (timerEl.dataset.pvLbTimerInit === 'true') return;
      timerEl.dataset.pvLbTimerInit = 'true';

      var duration = parseInt(timerEl.getAttribute('data-duration'), 10);
      if (!duration || duration < 1) duration = 1192;

      var remaining = duration;

      function tick() {
        if (remaining <= 0) remaining = duration;

        var hours = Math.floor(remaining / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;

        timerEl.textContent = padTime(hours) + ':' + padTime(minutes) + ':' + padTime(seconds);
        remaining -= 1;
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  function readPxVar(el, name, fallback) {
    var value = getComputedStyle(el).getPropertyValue(name).trim();
    if (!value) return fallback;
    return parseFloat(value) || fallback;
  }

  function initCircleGradients() {
    var rotations = [-22, 16, -38, 28, -14, 34];
    var gapFactors = [0.45, 1.2, 0.35, 1.45, 0.65, 1.05, 0.5, 1.35, 0.75, 1.15];
    var pairFactors = [0.9, 1.35, 1.05, 1.55, 0.85, 1.25];

    document.querySelectorAll('.js-pv-lb-circles').forEach(function (layer) {
      var section = layer.closest('.pv-long-blocks');
      if (!section) return;

      var url = layer.getAttribute('data-circle-url');
      if (!url) return;

      var gap = readPxVar(section, '--pv-lb-circle-gap', 200);
      var pairGap = readPxVar(section, '--pv-lb-circle-pair-gap', 200);
      var circleRatio = null;

      function placeCircles() {
        if (!circleRatio) return;

        layer.innerHTML = '';

        var zoneHeight = layer.clientHeight;
        if (zoneHeight <= 0) return;

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var isDesktop = window.matchMedia('(min-width: 768px)').matches;
        var maxWidth = isDesktop
          ? Math.min(1400, viewportWidth * 0.85)
          : Math.min(viewportWidth, viewportWidth * 0.9);
        var renderedHeight = maxWidth * circleRatio;
        var y = gap * 0.3;
        var index = 0;

        while (y + renderedHeight <= zoneHeight) {
          var side = index % 2 === 0 ? 'right' : 'left';
          var rot = rotations[index % rotations.length];
          var img = document.createElement('img');
          img.className = 'pv-long-blocks__circle pv-long-blocks__circle--' + side;
          img.src = url;
          img.alt = '';
          img.style.top = y + 'px';
          img.style.width = maxWidth + 'px';
          img.style.transformOrigin = 'center center';
          img.style.transform =
            (side === 'left' ? 'translateX(-50%) ' : 'translateX(50%) ') + 'rotate(' + rot + 'deg)';
          img.loading = index === 0 ? 'eager' : 'lazy';
          img.decoding = 'async';
          layer.appendChild(img);

          y += renderedHeight + gap * gapFactors[index % gapFactors.length];
          if (index % 2 === 1) {
            y += pairGap * pairFactors[Math.floor(index / 2) % pairFactors.length];
          }
          index += 1;
        }
      }

      function render() {
        gap = readPxVar(section, '--pv-lb-circle-gap', 200);
        pairGap = readPxVar(section, '--pv-lb-circle-pair-gap', 200);

        if (circleRatio) {
          placeCircles();
          return;
        }

        var probe = new Image();
        probe.decoding = 'async';
        probe.src = url;
        probe.onload = function () {
          if (!probe.naturalWidth || !probe.naturalHeight) return;
          circleRatio = probe.naturalHeight / probe.naturalWidth;
          placeCircles();
        };
      }

      if (layer.dataset.pvLbCirclesInit === 'true') {
        render();
        return;
      }
      layer.dataset.pvLbCirclesInit = 'true';

      render();

      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(function () {
          window.requestAnimationFrame(render);
        });
        observer.observe(section);
      } else {
        window.addEventListener('resize', render);
      }
    });
  }

  function initTabs() {
    document.querySelectorAll('.pv-long-blocks').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-pv-lb-tab]');
      if (!tabs.length || root.dataset.pvLbTabsInit === 'true') return;
      root.dataset.pvLbTabsInit = 'true';

      var panels = root.querySelectorAll('[data-pv-lb-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-pv-lb-tab');
          tabs.forEach(function (other) {
            var active = other === tab;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-pv-lb-panel') !== idx;
          });
        });
      });
    });
  }

  // Giveaway bundle "Free Gifts Recap" block: clicking its button submits
  // the page's main PDP Add to Cart form (product + free gifts) instead of
  // duplicating that cart logic in a second place. See GIVEAWAY-COORDINATION.md.
  function initGiveawayRecapButton() {
    document.querySelectorAll('[data-giveaway-recap-submit]').forEach(function (btn) {
      if (btn.dataset.pvLbRecapInit === 'true') return;
      btn.dataset.pvLbRecapInit = 'true';

      btn.addEventListener('click', function () {
        var mainForm = document.querySelector('[data-pv-atc-form]');
        if (!mainForm) return;
        if (typeof mainForm.requestSubmit === 'function') {
          mainForm.requestSubmit();
        } else {
          mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    });
  }

  function initPressCarousels() {
    var mobileQuery = window.matchMedia('(max-width: 767px)');

    document.querySelectorAll('.js-pv-lb-press').forEach(function (root) {
      if (root.dataset.pvLbPressInit === 'true') return;
      root.dataset.pvLbPressInit = 'true';

      var track = root.querySelector('[data-pv-lb-press-track]');
      var prevBtn = root.querySelector('[data-pv-lb-press-prev]');
      var nextBtn = root.querySelector('[data-pv-lb-press-next]');
      if (!track) return;

      function getSlides() {
        return Array.prototype.slice.call(track.querySelectorAll('[data-pv-lb-press-slide]'));
      }

      function getMaxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function getScrollLeftForIndex(index) {
        var slides = getSlides();
        if (!slides.length) return 0;

        var lastIndex = slides.length - 1;
        var targetIndex = index;
        if (targetIndex < 0) targetIndex = 0;
        if (targetIndex > lastIndex) targetIndex = lastIndex;

        if (targetIndex === 0) return 0;
        if (targetIndex === lastIndex) return getMaxScroll();

        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        return slides[targetIndex].offsetLeft - pad;
      }

      function clampScroll() {
        var maxScroll = getMaxScroll();
        if (track.scrollLeft < 0) track.scrollLeft = 0;
        if (track.scrollLeft > maxScroll) track.scrollLeft = maxScroll;
      }

      function getActiveIndex() {
        var slides = getSlides();
        if (!slides.length) return 0;

        var maxScroll = getMaxScroll();
        var scrollLeft = track.scrollLeft;
        var tolerance = 8;

        if (scrollLeft <= tolerance) return 0;
        if (scrollLeft >= maxScroll - tolerance) return slides.length - 1;

        var closest = 0;
        var minDist = Infinity;

        slides.forEach(function (_slide, i) {
          var dist = Math.abs(getScrollLeftForIndex(i) - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });

        return closest;
      }

      function scrollToIndex(index, behavior) {
        var slides = getSlides();
        if (!slides.length) return;

        var lastIndex = slides.length - 1;
        var targetIndex = index;
        if (targetIndex < 0) targetIndex = 0;
        if (targetIndex > lastIndex) targetIndex = lastIndex;

        track.scrollTo({
          left: getScrollLeftForIndex(targetIndex),
          behavior: behavior || 'smooth'
        });
      }

      function updateButtons() {
        if (!prevBtn || !nextBtn || !mobileQuery.matches) {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          return;
        }

        var maxScroll = getMaxScroll();
        var tolerance = 8;
        prevBtn.disabled = track.scrollLeft <= tolerance;
        nextBtn.disabled = track.scrollLeft >= maxScroll - tolerance;
      }

      function settleScroll() {
        if (!mobileQuery.matches) return;

        clampScroll();

        var maxScroll = getMaxScroll();
        var scrollLeft = track.scrollLeft;
        var tolerance = 8;
        var targetLeft = scrollLeft;

        if (scrollLeft <= tolerance) {
          targetLeft = 0;
        } else if (scrollLeft >= maxScroll - tolerance) {
          targetLeft = maxScroll;
        } else {
          targetLeft = getScrollLeftForIndex(getActiveIndex());
        }

        if (Math.abs(track.scrollLeft - targetLeft) > 1) {
          track.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }

        updateButtons();
      }

      function goTo(direction) {
        if (!mobileQuery.matches) return;
        scrollToIndex(getActiveIndex() + direction);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(1);
        });
      }

      track.addEventListener('scroll', updateButtons, { passive: true });

      if ('onscrollend' in window) {
        track.addEventListener('scrollend', settleScroll, { passive: true });
      } else {
        var scrollEndTimer;
        track.addEventListener(
          'scroll',
          function () {
            window.clearTimeout(scrollEndTimer);
            scrollEndTimer = window.setTimeout(settleScroll, 150);
          },
          { passive: true }
        );

        track.addEventListener(
          'touchend',
          function () {
            window.setTimeout(settleScroll, 220);
          },
          { passive: true }
        );
      }

      window.addEventListener('resize', function () {
        settleScroll();
      });
      updateButtons();
    });
  }

  function init() {
    updateAuthorDates();
    initOfferTimers();
    initCircleGradients();
    initTabs();
    initGiveawayRecapButton();
    initPressCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
